import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './core/navbar/navbar/navbar.component';
import { AlertComponent } from './core/alert/alert/alert.component';

declare const ibgSdk: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, AlertComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor() {
    if (typeof ibgSdk !== 'undefined' && ibgSdk?.init) {
      ibgSdk.init({
        token: '58f9235bc54c2a06ccf8312e76af3c6d',
      });
    }
  }
}
